import { PaymentService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { billingKeys } from './billingKeys';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.jobSubmissionPaymentMethodsByAccount>>;

export const createFetchJobSubmissionPaymentMethodsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId }], signal }: TParams) =>
    call(() => cancelOnSignal(PaymentService.billingAccountPaymentMethodListForJobSubmission({ baId }), signal));
